<template>
  <div>
    <div align="left" class="mt-5">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Referral Partner</h5>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-text class="bg-white border-right-0" slot="prepend">
              <img src="@/assets/filter.svg" alt />
            </b-input-group-text>
            <b-dropdown
              text="Filter Data"
              variant="light"
              toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
              slot="append"
            >
              <b-dropdown-item>Action A</b-dropdown-item>
              <b-dropdown-item>Action B</b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </b-col>
        <b-col class="text-right">
          <div>
            <b-dropdown
              :disabled="selected.length === 0"
              id="dropdown-1"
              text="Action"
              :variant="selected.length === 0 ? 'primary':'warning'"
              class="m-md-2"
            >
              <b-dropdown-item @click="submitStatus('publish')" href="#">Publish</b-dropdown-item>
              <b-dropdown-item @click="submitStatus('archive')" href="#">Archive</b-dropdown-item>
            </b-dropdown>
            <router-link :to="{name: 'createrefferalPartner'}">
              <b-button variant="primary">
                <img src="@/assets/create-new.svg" alt class="mr-2" /> Create New
              </b-button>
            </router-link>
          </div>
          <!-- <b-button variant="primary" @click="submitStatus()">
            <img src="@/assets/create-new.svg" alt class="mr-2" /> Send ID
          </b-button>-->
        </b-col>
      </b-row>
    </div>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right"></b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        responsive="sm"
        striped
        hover
        :items="getInfo"
        :per-page="perPage"
        :current-page="currentPage"
        :fields="fields"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
        empty-text="Data Empty"
      >
        <template v-slot:table-busy>
          <div class="text-center text-info my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:head(selected)="data" class="fas fa-check">
          <p class="fas fa-check">{{data.label}}</p>
        </template>
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th colspan="2"></b-th>
            <b-th colspan="2" class="text-center p-2">Publish Date</b-th>
            <b-th colspan="6"></b-th>
          </b-tr>
        </template>
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:cell(selected)="{ rowSelected, item, index }">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(category)="row">
          <p class="font-weight-bolder text-primary">{{row.value}}</p>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-primary" v-else-if="row.value == 'highlight'">Highlight</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(publish_date_start)="row">
          <div>{{row.value === "" ? "Present":row.value.substring(0,10)}}&nbsp;</div>
        </template>
        <template v-slot:cell(publish_date_end)="row">
          <div>&nbsp;{{row.value === "" ? "Present":row.value.substring(0,10)}}</div>
        </template>
        <template v-slot:cell(created_at)="row">{{row.value.substring(0,10)}}</template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="70px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editrefferalPartner', params: {id: item.id}}"
            class="text-dark"
          >
            <img class="mr-2" src="@/assets/ic-edit.svg" alt />
          </router-link>
          <!-- <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>-->
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mainProps: {
        blank: true,
        blankColor: '#777',
        width: 50,
        height: 50,
        class: 'm1',
      },
      loading: true,
      errored: false,
      selected_field_true: true,
      selected_field_false: false,
      items: [],
      selectMode: 'multi',
      selected: [],
      allSelected: false,
      indeterminate: false,
      fields: [
        {
          key: 'selected',
          class: 'text-center',
        },
        {
          key: 'created_at_date_only',
          label: 'Created',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'publish_date_start',
          label: 'Start',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'publish_date_end',
          label: 'End',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'referral_partner.code',
          label: 'Referral Code',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'referral_partner.name',
          label: 'Referral Partner Name',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'updated_at_date_only',
          label: 'Updated',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          class: 'text-center',
        },
        { key: 'action', label: 'Action', class: 'text-center' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      customerShow: false,
      counthighlight: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    },
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    // this.$store
    //   .dispatch("ArticleModule/getArticles")
    //   .then(response => {
    //     this.loading = false;
    //   })
    //   .catch(error => {
    //     this.$swal({
    //       type: "error",
    //       title: "Oops...",
    //       text: error.response.data.message,
    //       showConfirmButton: false,
    //       timer: 1500
    //     });
    //     this.loading = false;
    //   });
  },
  created() {
    // this.$store.watch(
    //   state => state.ArticleModule.articles,
    //   (newValue, oldValue) => {
    //     this.items = newValue;
    //   }
    // );
    this.$store.watch(
      state => state.ArticleModule.counthighlight,
      (newValue, oldValue) => {
        this.counthighlight = newValue;
      },
    );
  },
  mounted() {
    this.totalRows = this.items.length;
  },
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append('search_param', ctx.filter);
      formData.append('limit', ctx.perPage);
      formData.append('page', ctx.currentPage);
      formData.append('status', 'publish');
      formData.append('status', 'archive');
      this.$store
        .dispatch('RefferalPartnerModule/getRefferalPartners', formData)
        .then((response) => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // this.totalRows = filteredItems.length;
      // this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$refs.selectableTable.refresh();
          this.$store.dispatch('RefferalPartnerModule/delArticle', id);
          this.$swal('Deleted!', 'Your file has been deleted.', 'success');
        }
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      this.$swal({
        title: 'Are you sure?',
        text: `You will ${status} this On Article!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!',
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(this.selected, (key, value) => {
            formData.append('referral_partner_id', value.id);
            formData.append('status', status);
          });
          $.each(formData.getAll('referral_partner_id'), (key, value) => {
            console.log(value);
          });

          this.loading = true;

          this.$store
            .dispatch('RefferalPartnerModule/updateStatusPartners', formData)
            .then((response) => {
              this.loading = false;
              this.$refs.selectableTable.refresh();
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1000,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });

      // console.log(list);
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped>
.pointer-off {
  pointer-events: none;
}
</style>
